import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { SystemSettingsProvider } from './context/SystemSettingsContext';
import { LanguageProvider } from './context/LanguageContext';
import { AlarmNotificationProvider } from './context/AlarmNotificationContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <LanguageProvider>
      <SystemSettingsProvider>
        <AlarmNotificationProvider>
          <App />
        </AlarmNotificationProvider>
      </SystemSettingsProvider>
    </LanguageProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
